import type { IconNode } from '../types';

/**
 * @name ghost
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTB2MSIgLz4KICA8cGF0aCBkPSJNNy41MjggMjAuNDcyYTEuNiAxLjYgMCAwMTIuMjc3IDBsMS4wNTcgMS4wNTZhMS42IDEuNiAwIDAwMi4yNzYgMGwxLjA1Ny0xLjA1NmExLjYgMS42IDAgMDEyLjI3NyAwbDEuMTE0IDEuMTE0YTEuNCAxLjQgMCAwMDIuNDE0LTFWMTBhOCA4IDAgMDAtMTYgMHYxMC41ODZhMS40IDEuNCAwIDAwMi40MTQgMXoiIC8+CiAgPHBhdGggZD0iTTkgMTB2MSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/ghost
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Ghost: IconNode = [
  ['path', { d: 'M15 10v1' }],
  [
    'path',
    {
      d: 'M7.528 20.472a1.6 1.6 0 012.277 0l1.057 1.056a1.6 1.6 0 002.276 0l1.057-1.056a1.6 1.6 0 012.277 0l1.114 1.114a1.4 1.4 0 002.414-1V10a8 8 0 00-16 0v10.586a1.4 1.4 0 002.414 1z',
    },
  ],
  ['path', { d: 'M9 10v1' }],
];

export default Ghost;
